export default __webpack_public_path__ + "static/media/s2img3.1afc9583.png";